import type { GraphQLError } from 'graphql';

import { waitForAllReturnWhenError } from '@confluence/query-preloader-tools/entry-points/waitForAllReturnWhenError.ts';
import { query } from '@confluence/query-preloader-tools/entry-points/graphql.ts';
import { expVal } from '@confluence/feature-experiments';

import FolderOverviewFirstPageQueryNode, {
	type FolderOverviewFirstPageQuery$data,
	type FolderOverviewFirstPageQuery$variables,
} from './__generated__/FolderOverviewFirstPageQuery.graphql.ts';
import FolderRedirectFirstChildQueryNode, {
	type FolderRedirectFirstChildQuery$data,
	type FolderRedirectFirstChildQuery$variables,
} from './FolderLanding/__generated__/FolderRedirectFirstChildQuery.graphql.ts';

export async function preloadFolderData(contentId: string): Promise<
	| void
	| Error[]
	| {
			data: FolderRedirectFirstChildQuery$data | null;
			errors?: ReadonlyArray<GraphQLError>;
			hasErrors: boolean;
	  }[]
> {
	return waitForAllReturnWhenError([
		query<FolderOverviewFirstPageQuery$data, FolderOverviewFirstPageQuery$variables>({
			query: FolderOverviewFirstPageQueryNode,
			variables: {
				id: contentId,
				after: null,
				contentId,
				includeDevDocsSyncStatus: expVal('confluence_dev_docs', 'isEnabled', false),
			},
		}),
		query<FolderRedirectFirstChildQuery$data, FolderRedirectFirstChildQuery$variables>({
			query: FolderRedirectFirstChildQueryNode,
			variables: { id: contentId },
		}),
	]);
}
